<template>
    <div class="home">
        <swiper>
            <swiper-slide class="swiper-slide slide-one">
                <div style="width: 100%;text-align: center; margin-top: 6%;height: 100%">
                    <img src="../assets/img/logo.png" style="width: 280px;height: 280px"/>
                </div>
                <div style="width: 100% ;text-align: center;display: none">
                    <img src="../assets/img/sanyunziti.png" style="width: 160px;height: 24px;margin-top: 2px"/>
                </div>
                <div style="width: 100% ;text-align: center;">
                    <img src="../assets/img/sunyun_title.png" style="width: 50%;margin-top: 6%"/>
                </div>

                <p class="slogan" style="margin-top: 4%">汉光企业信息咨询(惠州市)有限公司</p>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    export default {
        name: "HelloWorld",

        data() {
            return {

            };
        },
        created() {
        },
        // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
        computed: {

        },
        mounted() {

        }
    };
</script>

<style lang="scss" scoped>
    /* .el-header {
      position: absolute;
    } */
    .swiper-slide {
        font-size: 24px;
        // text-align: center;
        // line-height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;

        .page {
            text-align: center;
            width: 100%;
            overflow: hidden;

            h3,
            p {
                font-size: 40px;
                font-weight: 400;
                color: #fff;
            }
        }

        .slogan {
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #d9a145;//b60a0a
            padding: 30px 0;
        }
    }

    //经典案例
    .case-item {
        width: 1100px;
        height: 500px;
        overflow: hidden;
        margin: 0 auto;
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;

        li {
            width: 330px;
            height: 250px;
            list-style: none;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
            margin: 5px;
            position: relative;
            overflow: hidden;

            &:hover {
                .case-item-hover {
                    opacity: 1;
                    transition: all 0.4s ease-in-out;
                }
            }
        }
    }

    //经典案例hover
    .case-item-hover {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        overflow: hidden;
        background-color: rgba(225, 56, 52, 0.7);

        .hover-title {
            height: 50px;
            color: #fff;
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 400;
            margin-top: 20px;
        }

        .bottom {
            border-bottom: 1px solid #fff;
            width: 60px;
            margin: 0 auto;
        }

        .more {
            width: 90px;
            padding: 5px 5px;
            margin: 0 auto;
            margin-top: 100px;
            border: 2px solid #fff;

            span {
                color: #fff;
                font-size: 20px;
            }
        }
    }

    // .swiper-slide:nth-child(2n) {
    //   background: skyblue;
    // }
    // .swiper-slide:nth-child(2n-1) {
    //   background: seashell;
    // }
    .slide-one {
        //background: url(../assets/img/home_top.png) no-repeat center;
        background-color: #1D2643;
        height: 100%;
        background-size: cover;
    }
    .order {
        order: -1;
    }

    .order-img {
        order: 1;
    }
</style>
